/**
 * Enum of supported toast variants
 */
export enum ToastVariants {
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning'
}
